<template>
  <div>
    <div
      class="max-w-5xl mx-auto relative py-10 px-4 grid-wrapper"
      v-if="reviewMeta.locationName"
      :style="cssProps"
    >
      <div
        class="p-4 flex justify-between items-center mb-4 rounded-lg flex-col sm:flex-row grid-header-container"
      >
        <div>
          <h2 class="text-xl font-semibold">
            {{ reviewMeta.locationName }}
          </h2>
          <div class="flex items-center mt-1">
            <span class="text-3xl font-bold mr-2">{{
              reviewMeta.averageRating.toFixed(1)
            }}</span>
            <div class="text-yellow-400 text-xl">
              ★★★★<span class="text-yellow-300"></span>
            </div>
            <span class="ml-2 text-sm" v-if="config && config.gridConfig"
              >{{ reviewMeta.totalReviewCount }}
              {{ config.gridConfig.reviewCountLabel || "reviews" }}</span
            >
            <img
              v-if="config.carouselConfig.showGoogleImage"
              src="https://configs.carthike.com/googlereviews/googleimage.png"
              alt="Google Logo"
              class="h-5 ml-2"
            />
          </div>
        </div>
        <a
          v-if="config && config.gridConfig"
          :href="reviewMeta.newReviewUri"
          target="_blank"
          class="text-white px-4 py-2 rounded transition write-review-button"
          >{{ config.gridConfig.reviewButtonLabel || "Leave a review" }}</a
        >
      </div>

      <div class="grid grid-cols-2 sm:grid-cols-2 carthike-grid-wrapper">
        <div
          class="rounded-lg shadow-lg overflow-hidden grid-card"
          v-for="(review, index) of displayedReviews"
          :key="index"
        >
          <div class="flex justify-center py-4">
            <img
              :src="review.reviewer.profilePhotoUrl"
              referrerpolicy="no-referrer"
              alt="Review image"
              class="w-8 h-8 rounded-full"
            />
          </div>
          <div class="p-4 flex flex-col items-center">
            <div class="shadow-md rounded px-2 py-1 mb-3 star-container">
              <span class="text-sm rating-stars"
                ><span v-for="index in review.starRating" :key="index"
                  >★</span
                ></span
              >
            </div>
            <p class="font-semibold text-sm mb-2 text-center">
              {{ review.reviewer.displayName }}
            </p>
            <p class="text-xs mb-2">
              {{ review.createReviewTime | dateFilter }}
            </p>
            <p
              class="text-xs text-center overflow-hidden text-ellipsis"
              style="display: -webkit-box; -webkit-line-clamp: 4; -webkit-box-orient: vertical;"
            >
              {{ review.comment ? review.comment : "" }}
            </p>
          </div>
        </div>
      </div>

      <!-- Load More Button -->
      <div class="text-center mt-6" v-if="hasMoreReviews">
        <button
          @click="loadMore"
          class="px-6 py-2 rounded transition write-review-button text-white"
        >
          {{ config.gridConfig.loadMoreButtonLabel || "Load More Reviews" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  components: {},
  data() {
    return {
      reviewMeta: {},
      reviews: {},
      currentPage: 1,
      itemsPerPage: 4,
      defaultReviewMeta: {
        newReviewUri: "https://google.com",
        averageRating: 4.599999904632568,
        totalReviewCount: 14,
        locationName: "Sample Company"
      },
      defaultReviews: {
        docs: [
          {
            _id: "sample1",
            reviewId: "review1",
            storeId: "store123",
            __v: 0,
            comment:
              "Great service and amazing products! The team was very helpful and professional. Would definitely recommend to others.",
            createReviewTime: 1710910638,
            createdAt: 1720198612,
            name: "accounts/sample/review1",
            reviewer: {
              profilePhotoUrl:
                "https://lh3.googleusercontent.com/a/ACg8ocK7S7bGVFA-5fztrseDQj2RB536D4xiZ5kH-RGD46VN81v-JA=s120-c-rp-mo-br100",
              displayName: "John Smith",
              _id: "reviewer1"
            },
            starRating: 5,
            updateReviewTime: 1710910638,
            updatedAt: 1722620725,
            id: "sample1"
          },
          {
            _id: "sample2",
            reviewId: "review2",
            storeId: "store123",
            __v: 0,
            comment:
              "Had some issues with delivery but customer service resolved them quickly. Product quality is good.",
            createReviewTime: 1708224237,
            createdAt: 1720198612,
            name: "accounts/sample/review2",
            reviewer: {
              profilePhotoUrl:
                "https://lh3.googleusercontent.com/a/ACg8ocK7S7bGVFA-5fztrseDQj2RB536D4xiZ5kH-RGD46VN81v-JA=s120-c-rp-mo-br100",
              displayName: "Mary Johnson",
              _id: "reviewer2"
            },
            starRating: 4,
            updateReviewTime: 1708224237,
            updatedAt: 1722620727,
            id: "sample2"
          },
          {
            _id: "sample3",
            reviewId: "review3",
            storeId: "store123",
            __v: 0,
            comment:
              "Excellent experience overall. Fast shipping and great communication throughout.",
            createReviewTime: 1669713601,
            createdAt: 1720198612,
            name: "accounts/sample/review3",
            reviewer: {
              profilePhotoUrl:
                "https://lh3.googleusercontent.com/a/ACg8ocK7S7bGVFA-5fztrseDQj2RB536D4xiZ5kH-RGD46VN81v-JA=s120-c-rp-mo-br100",
              displayName: "Robert Wilson",
              _id: "reviewer3"
            },
            starRating: 5,
            updateReviewTime: 1669713601,
            updatedAt: 1722620728,
            id: "sample3"
          },
          {
            _id: "sample4",
            reviewId: "review4",
            storeId: "store123",
            __v: 0,
            comment:
              "Product was okay but a bit overpriced compared to competitors.",
            createReviewTime: 1651348206,
            createdAt: 1720198612,
            name: "accounts/sample/review4",
            reviewer: {
              profilePhotoUrl:
                "https://lh3.googleusercontent.com/a/ACg8ocK7S7bGVFA-5fztrseDQj2RB536D4xiZ5kH-RGD46VN81v-JA=s120-c-rp-mo-br100",
              displayName: "Sarah Brown",
              _id: "reviewer4"
            },
            starRating: 3,
            updateReviewTime: 1651348206,
            updatedAt: 1722620730,
            id: "sample4"
          },
          {
            _id: "sample5",
            reviewId: "review5",
            storeId: "store123",
            __v: 0,
            comment:
              "Fantastic product and amazing value for money. Will definitely buy again!",
            createReviewTime: 1616054200,
            createdAt: 1720198612,
            name: "accounts/sample/review5",
            reviewer: {
              profilePhotoUrl:
                "https://lh3.googleusercontent.com/a/ACg8ocK7S7bGVFA-5fztrseDQj2RB536D4xiZ5kH-RGD46VN81v-JA=s120-c-rp-mo-br100",
              displayName: "James Davis",
              _id: "reviewer5"
            },
            starRating: 5,
            updateReviewTime: 1616054200,
            updatedAt: 1722620731,
            id: "sample5"
          }
        ],
        total: 5,
        limit: 5
      }
    };
  },
  computed: {
    displayedReviews() {
      return this.reviews.docs
        ? this.reviews.docs.slice(0, this.currentPage * this.itemsPerPage)
        : [];
    },
    hasMoreReviews() {
      return (
        this.reviews.docs &&
        this.currentPage * this.itemsPerPage < this.reviews.docs.length
      );
    },
    cssProps() {
      return {
        "--grid-card-background-color": `${this.config.gridConfig.cardBackgroundColor}`,
        "--grid-stars-color": `${this.config.gridConfig.starColor}`,
        "--grid-text-color": `${this.config.gridConfig.textColor}`,
        "--grid-button-background-color": `${this.config.gridConfig.buttonBackgroundColor}`,
        "--grid-container-background-color": `${this.config.gridConfig.containerBackgroundColor}`
      };
    }
  },
  filters: {
    dateFilter(value) {
      return format(new Date(value * 1000), "h:mm a, MMM dd");
    }
  },
  props: {
    config: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const store = this.$store.getters.getStore;
      this.$store
        .dispatch("getPublicReviews", { shop: store.shopOrigin })
        .then(response => {
          if (response.reviewMeta) {
            this.reviewMeta = response.reviewMeta;
            this.reviews = response.reviews;
          } else {
            this.reviewMeta = this.defaultReviewMeta;
            this.reviews = this.defaultReviews;
          }
        });
    },
    loadMore() {
      this.currentPage += 1;
    }
  }
};
</script>

<style scoped>
.grid-card {
  background: var(--grid-card-background-color);
  color: var(--grid-text-color);
}
.star-container {
  background: var(--grid-card-background-color);
}
.rating-stars {
  color: var(--grid-stars-color);
}
.write-review-button {
  background: var(--grid-button-background-color);
}
.grid-wrapper {
  background: var(--grid-container-background-color);
  color: var(--grid-text-color);
}
.carthike-grid-wrapper {
  grid-gap: 16px;
}
</style>
